import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../common/SectionTitle';

const PaymentsList = () => {
  return (
    <>
      <section
        className={`pricing-section position-relative z-2`}
      >
        <div className='container'>
            <div>
              <div className='row justify-content-center'>
                <div className='col-lg-12 col-md-10'>
                  <SectionTitle
                    // subtitle='Pricing'
                    variant='text-primary'
                    title='Explore our 10+ global and local payment methods'
                    description='Our experts have years of experience in fine-tuning payment strategies to our clients needs. With a presence in 19 countries, we have teams on the ground who deeply understand the intricacies of specific markets and can offer valuable payment advice for business expansion. '
                    centerAlign
                  />
                </div>
              </div>
            </div>
          <div className='row pb-20'>
            <div className='col-lg-4 col-md-6'>
              <div
                className='
                  position-relative
                  single-pricing-wrap
                  rounded-custom
                  bg-white
                  custom-shadow
                  p-5
                  mb-4 mb-lg-0
                '
              >
                <div className='pricing-header mb-20 text-center'>
                  <img
                      src="assets/img/AMEX-1.png"
                      alt="logo"
                      className="img-fluid logo-white"
                  />
                  <h3 className='package-name text-primary d-block'>American Express (Amex)</h3>
                </div>
                <Link
                    to='/request-for-demo'
                    className='btn btn-outline-primary mt-2 mb-4'
                >
                  Card
                </Link>
                <div className='pricing-info'>
                  A leading credit card provider for customers across the globe.
                  <br/>
                  <br/>
                </div>
                {/* <!--pattern start--> */}
                <div
                  className='
                    dot-shape-bg
                    position-absolute
                    z--1
                    left--40
                    bottom--40
                  '
                >
                  <img src='assets/img/shape/dot-big-square.svg' alt='shape' />
                </div>
                {/* <!--pattern end--> */}
              </div>
            </div>

            <div className='col-lg-4 col-md-6'>
              <div
                  className='
                  position-relative
                  single-pricing-wrap
                  rounded-custom
                  bg-white
                  custom-shadow
                  p-5
                  mb-4 mb-lg-0
                '
              >
                <div className='pricing-header mb-20 text-center'>
                  <img
                      src="assets/img/Mastercard-1.png"
                      alt="logo"
                      className="img-fluid logo-white"
                  />
                  <h3 className='package-name text-primary d-block'>Mastercard</h3>
                </div>
                <Link
                    to='/request-for-demo'
                    className='btn btn-outline-primary mt-2 mb-4'
                >
                  Card
                </Link>
                <div className='pricing-info'>
                  A major global card provider, which accounted for about 170 billion transactions in 2023 alone.
                </div>
                {/* <!--pattern start--> */}
                <div
                    className='
                    dot-shape-bg
                    position-absolute
                    z--1
                    left--40
                    bottom--40
                  '
                >
                  <img src='assets/img/shape/dot-big-square.svg' alt='shape' />
                </div>
                {/* <!--pattern end--> */}
              </div>
            </div>

            <div className='col-lg-4 col-md-6'>
              <div
                  className='
                  position-relative
                  single-pricing-wrap
                  rounded-custom
                  bg-white
                  custom-shadow
                  p-5
                  mb-4 mb-lg-0
                '
              >
                <div className='pricing-header mb-20 text-center'>
                  <img
                      src="assets/img/PayPal-1.png"
                      alt="logo"
                      className="img-fluid logo-white"
                  />
                  <h3 className='package-name text-primary d-block'>PayPal</h3>
                </div>

                <div className='row'>
                  <div className='col-lg-6 col-md-12'>
                    <Link
                        to='/request-for-demo'
                        className='btn btn-outline-primary mt-2 mb-4'
                    >
                      Digital Wallet
                    </Link>
                  </div>
                  <div className='col-lg-5 col-md-12'>
                    <Link
                        to='/request-for-demo'
                        className='btn btn-outline-primary mt-2 mb-4'
                    >
                      Mobile
                    </Link>
                  </div>
                </div>

                <div className='pricing-info'>
                  A leading global payment method that supports eWallet and Buy Now Pay Later payments.
                </div>
                {/* <!--pattern start--> */}
                <div
                    className='
                    dot-shape-bg
                    position-absolute
                    z--1
                    left--40
                    bottom--40
                  '
                >
                  <img src='assets/img/shape/dot-big-square.svg' alt='shape' />
                </div>
                {/* <!--pattern end--> */}
              </div>
            </div>
          </div>

          <div className='row pb-40'>
            <div className='col-lg-4 col-md-6'>
              <div
                  className='
                  position-relative
                  single-pricing-wrap
                  rounded-custom
                  bg-white
                  custom-shadow
                  p-5
                  mb-4 mb-lg-0
                '
              >
                <div className='pricing-header mb-20 text-center'>
                  <img
                      src="assets/img/Visa.png"
                      alt="logo"
                      className="img-fluid logo-white"
                  />
                  <h3 className='package-name text-primary d-block'>Visa</h3>
                </div>
                <Link
                    to='/request-for-demo'
                    className='btn btn-outline-primary mt-2 mb-4'
                >
                  Card
                </Link>
                <div className='pricing-info'>
                  A major card provider, with more than 4.3 billion cards in circulation worldwide.
                  <br/>
                  <br/>
                  <br/>
                </div>
                {/* <!--pattern start--> */}
                <div
                    className='
                    dot-shape-bg
                    position-absolute
                    z--1
                    left--40
                    bottom--40
                  '
                >
                  <img src='assets/img/shape/dot-big-square.svg' alt='shape' />
                </div>
                {/* <!--pattern end--> */}
              </div>
            </div>

            <div className='col-lg-4 col-md-6'>
              <div
                  className='
                  position-relative
                  single-pricing-wrap
                  rounded-custom
                  bg-white
                  custom-shadow
                  p-5
                  mb-4 mb-lg-0
                '
              >
                <div className='pricing-header mb-20 text-center'>
                  <img
                      src="assets/img/Diners-1.png"
                      alt="logo"
                      className="img-fluid logo-white"
                  />
                  <h3 className='package-name text-primary d-block'>Diners Club</h3>
                </div>
                <Link
                    to='/request-for-demo'
                    className='btn btn-outline-primary mt-2 mb-4'
                >
                  Card
                </Link>
                <div className='pricing-info'>
                  Diners Club is a well-known international charge card and credit card brand, renowned for its exclusive benefits and premium services.
                </div>
                {/* <!--pattern start--> */}
                <div
                    className='
                    dot-shape-bg
                    position-absolute
                    z--1
                    left--40
                    bottom--40
                  '
                >
                  <img src='assets/img/shape/dot-big-square.svg' alt='shape' />
                </div>
                {/* <!--pattern end--> */}
              </div>
            </div>

            <div className='col-lg-4 col-md-6'>
              <div
                  className='
                  position-relative
                  single-pricing-wrap
                  rounded-custom
                  bg-white
                  custom-shadow
                  p-5
                  mb-4 mb-lg-0
                '
              >
                <div className='pricing-header mb-20 text-center'>
                  <img
                      src="assets/img/Discover-2.png"
                      alt="logo"
                      className="img-fluid logo-white"
                  />
                  <h3 className='package-name text-primary d-block'>Discover</h3>
                </div>
                <Link
                    to='/request-for-demo'
                    className='btn btn-outline-primary mt-2 mb-4'
                >
                  Card
                </Link>
                <div className='pricing-info'>
                  A popular US card brand, adopted by many customers across the globe.
                  <br/>
                  <br/>
                  <br/>
                </div>
                {/* <!--pattern start--> */}
                <div
                    className='
                    dot-shape-bg
                    position-absolute
                    z--1
                    left--40
                    bottom--40
                  '
                >
                  <img src='assets/img/shape/dot-big-square.svg' alt='shape' />
                </div>
                {/* <!--pattern end--> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PaymentsList;
